exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3vPW84jPRQhm--16_M56Co{height:16px}._22JBca5rZPOh2O0UODsMGh{cursor:pointer;white-space:nowrap;text-decoration:none}.hXps3FAg1WjedFve_0TVj{font-weight:600}.BUvqnrojLQmaG2KmKS1Ag:after{content:\" \"}", ""]);

// exports
exports.locals = {
	"recipientRowIcon": "_3vPW84jPRQhm--16_M56Co",
	"link": "_22JBca5rZPOh2O0UODsMGh",
	"recipientName": "hXps3FAg1WjedFve_0TVj",
	"blankSpaceAfter": "BUvqnrojLQmaG2KmKS1Ag"
};